<template>
  <v-container fluid>
    <v-card class="mx-auto" raised elevation="5" style="width:100%">
      <v-row>
        <v-col cols="4" sm="4">
          <v-card max-width="434" raised elevation="10" color="appcolor" height="100%" style="margin-left:12px">
            <!-- <v-img height="100%" src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg"> -->
              <v-row align="end" class="fill-height">
                <v-col align="center" class="pa-2" cols="12">
                  <v-avatar class="profile" color="grey" size="200"  >                  
                    <img id="profilePhotoB" />
                  </v-avatar>
                  <v-list-item color="rgba(0, 0, 0, .4)" dark>
                    <v-list-item-content>
                      <v-list-item-title class="title">{{fullName}}</v-list-item-title>
                      <v-list-item-subtitle>{{userInfo.jobTitle}}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{userInfo.mail}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col align="center" class="py-0">
                  
                </v-col>
              </v-row>
            <!-- </v-img> -->
          </v-card>
        </v-col>
        <v-col cols="4" md="4">
          <v-card class="mx-auto" max-width="98%" raised elevation="10">
            <v-app-bar dark dense color="appcolor">
              <h4>{{userInfo.displayName}}</h4>
              <v-spacer></v-spacer>
            </v-app-bar>
    

              
         
              <v-divider inset></v-divider>
              
            <v-list >

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="appcolor">mdi-facebook-workplace</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-if="userInfo.jobTitle">{{userInfo.jobTitle}}</v-list-item-title>
                  <v-list-item-subtitle>Designation</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
               <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="appcolor">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-if="userInfo.businessPhones">{{userInfo.businessPhones[0]}}</v-list-item-title>
                  <v-list-item-subtitle>Work</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="appcolor">mdi-cellphone-basic</v-icon>
                </v-list-item-icon>
               

                <v-list-item-content>
                  <v-list-item-title v-if="userInfo.mobile">{{userInfo.mobile}}</v-list-item-title>
                  <v-list-item-title v-if="!userInfo.mobile">Not available</v-list-item-title>
                  <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                </v-list-item-content>
              
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="appcolor">mdi-email</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{userInfo.mail}}</v-list-item-title>
                  <v-list-item-subtitle>Work</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="appcolor">mdi-map-marker</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{userInfo.officeLocation}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
import axios from "axios";
import customFunctions from "../codeFiles/taskHelper.js";
//import MessageSheet from "@/components/MessageSheet.vue";
import AuthService from "../codeFiles/auth/auth.service.js";
import graphConfig from "../codeFiles/auth/graphConfig.js";

export default {
  name: "UserProfile",
  data() {
    return {
      userInfo: [],
      profilePhoto: null,
    };
  },
  async created() {
    this.authService = new AuthService();
    this.user = this.authService.app.getAccount();
    //this.userInfo = this.authService.userProfile();

    //console.log(JSON.stringify(this.userInfo));
    await this.authService.getToken().then((token) => {
      axios(graphConfig.graphMeEndpoint, {
        headers: {
          Authorization: "Bearer " + token.accessToken,
        },
      })
        .then((response) => {
          // JSON responses are automatically parsed.

          this.userInfo = response.data;         
          this.getPhoto();
          //console.log(this.items);
        })
        .catch((e) => {
          console.log(e);
        });
    });
  },
  components: {
    //  MessageSheet,
  },
  watch: {
    profilePhoto: function () {      
      return this.profilePhoto;
    },
  },
  computed: {
    fullName() {
      return this.userInfo.givenName + " " + this.userInfo.surname;
    },
  },
  methods: {
    async getPhoto() {
      await this.authService.getToken().then((token) => {
        axios(graphConfig.graphPhotoEndpoint, {
          headers: {
            Authorization: "Bearer " + token.accessToken,
          },
          responseType: "blob",
        })
          .then((response) => {
            var reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onloadend = function () {
              this.profilePhoto = reader.result;
              var icon_elem = document.getElementById("profilePhotoB");
              icon_elem.src = this.profilePhoto;
            };
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
  },
};
</script>